var _g, _rect, _path, _circle, _circle2, _circle3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _g2, _rect22, _path2, _circle4, _circle5, _circle6, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCodeBuddy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 669,
    height: 409,
    viewBox: "0 0 669 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 152,
    width: 281,
    height: 99,
    fill: "#262626"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    width: 389,
    height: 235,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 10C46 4.47715 50.4772 0 56 0H425C430.523 0 435 4.47715 435 10V29H46V10Z",
    fill: "#E3E3E3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 414.5,
    cy: 15.5,
    r: 7.5,
    fill: "#DE623C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 392.5,
    cy: 15.5,
    r: 7.5,
    fill: "#EAC400"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.5,
    cy: 15.5,
    r: 7.5,
    fill: "#2B9A29"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 45,
    width: 76,
    height: 12,
    rx: 6,
    fill: "#262626",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 62,
    width: 76,
    height: 12,
    rx: 6,
    fill: "#262626",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 99,
    width: 29,
    height: 12,
    rx: 6,
    fill: "#F91400",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 99,
    width: 37,
    height: 12,
    rx: 6,
    fill: "#262626",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 79,
    width: 85,
    height: 12,
    rx: 6,
    fill: "#262626",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 133,
    width: 62,
    height: 12,
    rx: 6,
    fill: "#262626",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 133,
    width: 29,
    height: 12,
    rx: 6,
    fill: "#1CEF18",
    fillOpacity: 0.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 167,
    width: 30,
    height: 12,
    rx: 6,
    fill: "#8000FF",
    fillOpacity: 0.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 201,
    width: 23,
    height: 12,
    rx: 6,
    fill: "#262626",
    fillOpacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 201,
    width: 67,
    height: 12,
    rx: 6,
    fill: "#262626",
    fillOpacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 184,
    width: 99,
    height: 12,
    rx: 6,
    fill: "#262626",
    fillOpacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 184,
    width: 31,
    height: 12,
    rx: 6,
    fill: "#262626",
    fillOpacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 167,
    width: 67,
    height: 12,
    rx: 6,
    fill: "#262626",
    fillOpacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 150,
    width: 67,
    height: 12,
    rx: 6,
    fill: "#4285F4",
    fillOpacity: 0.6
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 116,
    width: 85,
    height: 12,
    rx: 6,
    fill: "#262626",
    fillOpacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 79,
    width: 21,
    height: 12,
    rx: 6,
    fill: "#8000FF",
    fillOpacity: 0.6
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 62,
    width: 25,
    height: 12,
    rx: 6,
    fill: "#262626",
    fillOpacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 45,
    width: 62,
    height: 12,
    rx: 6,
    fill: "#0099FF",
    fillOpacity: 0.6
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 62,
    width: 96,
    height: 12,
    rx: 6,
    fill: "#262626",
    fillOpacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 45,
    width: 76,
    height: 12,
    rx: 6,
    fill: "#262626",
    fillOpacity: 0.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 252,
    width: 281,
    height: 57,
    fill: "#262626"
  }))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 96,
    width: 389,
    height: 235,
    rx: 10,
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225 106C225 100.477 229.477 96 235 96H604C609.523 96 614 100.477 614 106V125H225V106Z",
    fill: "#4E4E4E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 593.5,
    cy: 111.5,
    r: 7.5,
    fill: "#DE623C"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.5,
    cy: 111.5,
    r: 7.5,
    fill: "#EAC400"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.5,
    cy: 111.5,
    r: 7.5,
    fill: "#2B9A29"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 141,
    width: 76,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 158,
    width: 76,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 195,
    width: 29,
    height: 12,
    rx: 6,
    fill: "#F91400",
    fillOpacity: 0.6
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 195,
    width: 37,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 175,
    width: 85,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 229,
    width: 62,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 229,
    width: 29,
    height: 12,
    rx: 6,
    fill: "#1CEF18",
    fillOpacity: 0.6
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 263,
    width: 30,
    height: 12,
    rx: 6,
    fill: "#8000FF",
    fillOpacity: 0.6
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 311,
    y: 297,
    width: 23,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 297,
    width: 67,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 280,
    width: 99,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 280,
    width: 31,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 263,
    width: 67,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 246,
    width: 67,
    height: 12,
    rx: 6,
    fill: "#4285F4",
    fillOpacity: 0.6
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 212,
    width: 85,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 175,
    width: 21,
    height: 12,
    rx: 6,
    fill: "#8000FF",
    fillOpacity: 0.6
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 158,
    width: 25,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 141,
    width: 62,
    height: 12,
    rx: 6,
    fill: "#0099FF",
    fillOpacity: 0.6
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 158,
    width: 96,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 141,
    width: 76,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0,
    y: 52,
    width: 481,
    height: 299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 188,
    y: 152,
    width: 481,
    height: 257,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeBuddy);
export default __webpack_public_path__ + "static/media/CodeBuddy.4585d264f0fbbe425965e61b0d082140.svg";
export { ForwardRef as ReactComponent };